








import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class UserUnconfirmedReportsLink extends Vue {
  @Prop() private userId!: number;
  @Prop() private username!: string;
  @Prop() private isCurrentUser!: boolean;
  @Prop() private lang!: string;

  get toRoute() {
    const params = {lang: this.lang, username: this.username};
    return this.isCurrentUser
      ? {name: 'unconfirmed_by_me', params}
      : {name: 'unconfirmed_by_user', params};
  }
}
